var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./SubmissionFormCancel.jinja');
require('./SubmissionFormCancel.less');


module.exports = Base.extend({

    template: template,

    events: {
        'click .SubmissionFormCancel-yesButton': 'onYesClick',
        'click .SubmissionFormCancel-noButton': 'onNoClick',
        'click': 'onBGClick'
    },


    initialize: function (options) {

        _.bindAll(this, 'onKeyDown');

        Base.prototype.initialize.call(this, options);
    },


    show: function (params) {
        params = params || {};

        $('body').on('keydown', this.onKeyDown);

        this.cb = params.cb;
        this.$el.addClass('SubmissionFormCancel--visible');
    },


    hide: function () {
        $('body').off('keydown', this.onKeyDown);

        this.$el.removeClass('SubmissionFormCancel--visible');
    },


    onBGClick: function (e) {
        if ($(e.target).closest('.SubmissionFormCancel-body').length) return;

        this.onNoClick();
    },

    onKeyDown: function (e) {
        if (e.keyCode == 27) { //esc
            e.stopPropagation();

            this.onNoClick();
        }
    },


    onNoClick: function () {
        this.hide();

        this.cb && this.cb(false);
    },


    onYesClick: function () {
        this.hide();

        this.cb && this.cb(true);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionFormCancel/SubmissionFormCancel.js
// module id = 128
// module chunks = 0